// import Layout from "@/views/layout/layout";
import mOtpLayout from "@/views/layout/mOtpLayout";
const rootPath = "/authSer";

const auth = {
  path: rootPath,
  name: "auth",
  description: "인증/보안",
  redirect: { name: "findId" },
  component: mOtpLayout,
  children: [
    {
      path: "findId",
      name: "findId",
      redirect: { name: "findIdStep1" },
      description: "사용자ID조회",
      component: () => import("@/views/templates/auth/findIdStepParent"),
      children: [
        {
          path: "step1",
          name: "findIdStep1",
          component: () => import("@/views/templates/auth/findIdStep1"),
          meta: {
            layout: "default",
            transparent: true,
            step: 1,
          },
        },
        {
          path: "step2",
          name: "findIdStep2",
          component: () => import("@/views/templates/auth/findIdStep2"),
          meta: {
            layout: "default",
            transparent: true,
            step: 2,
          },
        },
        {
          path: "step3",
          name: "findIdStep3",
          component: () => import("@/views/templates/auth/findIdStep3"),
          meta: {
            layout: "default",
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "findIdByLogin",
      name: "findIdByLogin",
      component: () => import("@/views/templates/auth/findIdStep3"),
      meta: {
        layout: "default",
        transparent: true,
      },
    },
    {
      path: "changePassword",
      name: "changePassword",
      description: "사용자암호변경/재등록",
      redirect: { name: "changePasswordParent" },
      component: () => import("@/views/templates/auth/changePassword"),
      children: [
        {
          path: "changePasswordParent",
          name: "changePasswordParent",
          description: "사용자암호변경/재등록 메뉴선택",
          component: () => import("@/views/templates/auth/changePasswordParent"),
          meta: {
            transparent: true,
            layout: "default",
          },
        },
        {
          path: "changePasswordKnowStepParent",
          name: "changePasswordKnowStepParent",
          description: "사용자 암호 알때/로그인",
          redirect: { name: "changePasswordKnowStep1" },
          component: () => import("@/views/templates/auth/changePasswordKnowStepParent"),
          children: [
            {
              path: "step1",
              name: "changePasswordKnowStep1",
              description: "사용자 암호 알때/로그인 step1",
              component: () => import("@/views/templates/auth/changePasswordKnowStep1"),
              meta: {
                layout: "default",
                transparent: true,
                roles: ["login", "master"],
                step: 1,
              },
            },
            {
              path: "step2",
              name: "changePasswordKnowStep2",
              description: "사용자 암호 알때/로그인 step2",
              component: () => import("@/views/templates/auth/changePasswordKnowStep2"),
              meta: {
                layout: "default",
                transparent: true,
                roles: ["login", "master"],
                isLast: true,
              },
            },
          ],
        },
        {
          path: "changePasswordForgottenParent",
          name: "changePasswordForgottenParent",
          description: "사용자 암호 모를때/비로그인",
          redirect: { name: "changePasswordForgottenStep1" },
          component: () => import("@/views/templates/auth/changePasswordForgottenParent"),
          children: [
            {
              path: "step1",
              name: "changePasswordForgottenStep1",
              description: "사용자 암호 모를때/비로그인 step1",
              component: () => import("@/views/templates/auth/changePasswordForgottenStep1"),
              meta: {
                layout: "default",
                transparent: true,
                step: 1,
              },
            },
            {
              path: "step2",
              name: "changePasswordForgottenStep2",
              description: "사용자 암호 모를때/비로그인 step2",
              component: () => import("@/views/templates/auth/changePasswordForgottenStep2"),
              meta: {
                layout: "default",
                transparent: true,
                step: 2,
              },
            },
            {
              path: "step3",
              name: "changePasswordForgottenStep3",
              description: "사용자 암호 모를때/비로그인 step3",
              component: () => import("@/views/templates/auth/changePasswordForgottenStep3"),
              meta: {
                layout: "default",
                transparent: true,
                isLast: true,
              },
            },
          ],
        },
        {
          path: "userCipher3TmErrReq",
          name: "userCipher3TmErrReq",
          description: "사용자 암호 오류해제/비로그인",
          redirect: { name: "userCipher3TmErrReqForgetStep1" },
          component: () => import("@/views/templates/auth/userCipher3TmErrReq"),
          children: [
            {
              path: "step1",
              name: "userCipher3TmErrReqForgetStep1",
              description: "사용자 암호 오류해제/비로그인 step1",
              component: () => import("@/views/templates/auth/userCipher3TmErrReqForgetStep1"),
              meta: {
                layout: "default",
                transparent: true,
                step: 1,
              },
            },
            {
              path: "step2",
              name: "userCipher3TmErrReqForgetStep2",
              description: "사용자 암호 오류해제/비로그인 step2",
              component: () => import("@/views/templates/auth/userCipher3TmErrReqForgetStep2"),
              meta: {
                layout: "default",
                transparent: true,
                step: 2,
              },
            },
            {
              path: "step2",
              name: "userCipher3TmErrReqKnowStep2",
              description: "사용자 암호 오류해제/암호알때 step2",
              component: () => import("@/views/templates/auth/userCipher3TmErrReqKnowStep2"),
              meta: {
                layout: "default",
                transparent: true,
                step: 2,
              },
            },
            {
              path: "step3",
              name: "userCipher3TmErrReqForgetStep3",
              description: "사용자 암호 오류해제/비로그인 step3",
              component: () => import("@/views/templates/auth/userCipher3TmErrReqForgetStep3"),
              meta: {
                layout: "default",
                transparent: true,
                isLast: true,
              },
            },
          ],
        },
        {
          path: "once",
          name: "changePasswordOnce",
          description: "사용자 암호 모를때/비로그인",
          redirect: { name: "changePasswordOnceStep1" },
          component: () => import("@/views/templates/auth/changePasswordOnceParent"),
          children: [
            {
              path: "step1",
              name: "changePasswordOnceStep1",
              description: "처음 사용자 암호 변경 step1",
              component: () => import("@/views/templates/auth/changePasswordOnceStep1"),
              meta: {
                layout: "default",
                roles: ["login"],
                step: 1,
                goback: false,
                menu: false,
              },
            },
            {
              path: "step2",
              name: "changePasswordOnceStep2",
              description: "처음 사용자 암호 변경 step2 - 간편 PIN번호 발급 안내",
              component: () => import("@/views/templates/auth/changePasswordOnceStep2"),
              meta: {
                layout: "default",
                roles: ["login"],
                step: 2,
              },
            },
            {
              path: "step3",
              name: "changePasswordOnceStep3",
              description: "처음 사용자 암호 변경 step3 - 완료",
              component: () => import("@/views/templates/auth/changePasswordOnceStep3"),
              meta: {
                layout: "default",
                roles: ["login"],
                isLast: true,
                transparent: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: "vtnGuideEkyc",
      name: "vtnGuideEkyc",
      redirect: { name: "vtnGuideEkycInfo" },
      description: "베트남 생체정보검증 이용 가이드",
      component: () => import("@/views/templates/auth/vtnGuideEkycInfo"),
      children: [
        {
          path: "vtnGuideEkycInfo",
          name: "vtnGuideEkycInfo",
          description: "베트남 생체정보검증 이용 가이드",
          component: () => import("@/views/templates/auth/vtnGuideEkycInfo"),
          meta: {
            layout: "default",
          },
        },
      ],
    },
    {
      path: "ekycLogin",
      name: "ekycLogin",
      description: "기기변경여부 1 && 생체정보등록여부 1 로그인",
      component: () => import("@/views/templates/auth/EkycLoginPopup"),
      meta: {
        roles: ["login"],
      },
    },
    {
      path: "createEkyc",
      name: "createEkyc",
      redirect: { name: "createEkycEnter" },
      description: "베트남 생체정보 등록",
      component: () => import("@/views/templates/auth/createEkycParent"),
      children: [
        {
          path: "enter",
          name: "createEkycEnter",
          description: "내국인 생체정보 등록 Enter",
          component: () => import("@/views/templates/auth/createEkycEnter"),
          meta: {
            roles: ["login", "ppsn"],
          },
        },
        {
          path: "confirm",
          name: "createEkycConfirm",
          description: "내국인 생체정보 등록 정보 확인",
          component: () => import("@/views/templates/auth/createEkycConfirm"),
          meta: {
            roles: ["login"],
            transparent: true,
          },
        },
        {
          path: "enter",
          name: "createForgnEkycEnter",
          description: "외국인 생체정보 등록 Enter",
          component: () => import("@/views/templates/auth/createForgnEkycEnter"),
          meta: {
            roles: ["login", "ppsn"],
          },
        },
        {
          path: "confirm",
          name: "createForgnEkycConfirm",
          description: "외국인 생체정보 등록 정보 확인",
          component: () => import("@/views/templates/auth/createForgnEkycConfirm"),
          meta: {
            roles: ["login"],
            transparent: true,
          },
        },
        {
          path: "completeSucc",
          name: "createEkycSuccess",
          description: "생체정보 등록 성공",
          component: () => import("@/views/templates/auth/createEkycSuccess"),
          meta: {},
        },
        {
          path: "completeFail",
          name: "createEkycFail",
          description: "생체정보 등록 실패",
          component: () => import("@/views/templates/auth/createEkycFail"),
          meta: {},
        },
      ],
    },
    {
      path: "userGuideMotp",
      name: "userGuideMotp",
      redirect: { name: "userGuideMotpInfo1" },
      description: "mOTP 이용가이드",
      component: () => import("@/views/templates/auth/userGuideMotp"),
      children: [
        {
          path: "userGuideMotpInfo1",
          name: "userGuideMotpInfo1",
          description: "이용가이드 (모바일otp) info-guide-01~04",
          component: () => import("@/views/templates/auth/userGuideMotpInfo1"),
          meta: {
            //roles: ["login"],
            layout: "default",
          },
        },
      ],
    },
    {
      path: "createMotp",
      name: "createMotp",
      redirect: { name: "createMotpStep1" },
      component: () => import("@/views/templates/auth/createMotp"),
      children: [
        {
          path: "step1",
          name: "createMotpStep1",
          description: "mOTP 발급/재발급-step1(모바일 OTP 소개) page-03-01-01",
          component: () => import("@/views/templates/auth/createMotpStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step11",
          name: "createMotpStep11",
          description: "mOTP 발급/재발급-step11(재발급 안내) page-03-02-01",
          component: () => import("@/views/templates/auth/createMotpStep11"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "createMotpStep2",
          description: "mOTP 발급/재발급-step2(계좌 인증) page-01-06-01",
          component: () => import("@/views/templates/auth/createMotpStep2"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "step3",
          name: "createMotpStep3",
          description: "mOTP 발급/재발급-step3(sms, email, tokenOTP 인증 선택) page-01-09-01",
          component: () => import("@/views/templates/auth/createMotpStep3"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "step4",
          name: "createMotpStep4",
          description: "mOTP 발급/재발급-step4(sms, email 인증) page-01-07-01, page-01-07-01-02",
          component: () => import("@/views/templates/auth/createMotpStep4"),
          meta: {
            roles: ["login"],
            step: 4,
          },
        },
        {
          path: "step5",
          name: "createMotpStep5",
          description: "mOTP 발급/재발급-step5(otp 인증) page-01-10-01",
          component: () => import("@/views/templates/auth/createMotpStep5"),
          meta: {
            roles: ["login"],
            step: 4,
          },
        },
        {
          path: "step6",
          name: "createMotpStep6",
          description: "mOTP 발급/재발급-step6(하루이체한도) page-01-03-01",
          component: () => import("@/views/templates/auth/createMotpStep6"),
          meta: {
            roles: ["login"],
            step: 5,
          },
        },
        {
          path: "step7",
          name: "createMotpStep7",
          description: "mOTP 발급/재발급-step7(한번에이체한도) page-01-04-01",
          component: () => import("@/views/templates/auth/createMotpStep7"),
          meta: {
            roles: ["login"],
            step: 6,
          },
        },
        {
          path: "step8",
          name: "createMotpStep8",
          description: "mOTP 발급/재발급-step8(인증코드 입력방법) page-01-05-01",
          component: () => import("@/views/templates/auth/createMotpStep8"),
          meta: {
            roles: ["login"],
            step: 7,
          },
        },
        {
          path: "step9",
          name: "createMotpStep9",
          description: "mOTP 발급/재발급-step9(mPIN 입력) page-01-01-01",
          component: () => import("@/views/templates/auth/createMotpStep9"),
          meta: {
            roles: ["login"],
            step: 8,
          },
        },
        {
          path: "step10",
          name: "createMotpStep10",
          description: "mOTP 발급/재발급-step10(발급완료) page-03-04-01",
          component: () => import("@/views/templates/auth/createMotpStep10"),
          meta: {
            roles: ["login"],
            transparent: true,
            isLast: true,
          },
        },
      ],
    },
    {
      path: "changeMotpPin",
      name: "changeMotpPin",
      redirect: { name: "changeMotpPinStep1" },
      component: () => import("@/views/templates/auth/changeMotpPin"),
      children: [
        {
          path: "step1",
          name: "changeMotpPinStep1",
          description: "mOTP PIN관리 MOTP-05-01-01",
          component: () => import("@/views/templates/auth/changeMotpPinStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "changeMotpPinStep2",
          description: "mOTP PIN관리 >  MOTP PIN 인증 MOTP-01-08-01 ",
          component: () => import("@/views/templates/auth/changeMotpPinStep2"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "step2-1",
          name: "changeMotpPinStep2-1",
          description: "mOTP PIN관리 >  계좌 인증 MOTP-01-06-01 ",
          component: () => import("@/views/templates/auth/changeMotpPinStep2-1"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },

        {
          path: "step3",
          name: "changeMotpPinStep3",
          description: "mOTP PIN관리 > PIN 번호 변경 > MOTP PIN 인증 > PIN번호 입력 MOTP-01-01-01",
          component: () => import("@/views/templates/auth/changeMotpPinStep3"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "step3-1",
          name: "changeMotpPinStep3-1",
          description: "mOTP PIN관리 > 본인인증 MOTP-01-07-01",
          component: () => import("@/views/templates/auth/changeMotpPinStep3-1"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        // {
        //   path: "step4",
        //   name: "changeMotpPinStep4",
        //   description: "mOTP PIN관리 > PIN 번호 변경 > PIN번호 확인 입력 MOTP-01-01-02",
        //   component: () => import("@/views/templates/auth/changeMotpPinStep4"),
        //   meta: {
        //     roles: ["login"],
        //   },
        // },
        {
          path: "step4-1",
          name: "changeMotpPinStep4-1",
          description: "mOTP PIN관리 > PIN 분실 변경 > MOTP PIN 인증 > PIN번호 입력 MOTP-01-01-01",
          component: () => import("@/views/templates/auth/changeMotpPinStep3"),
          meta: {
            roles: ["login"],
            step: 4,
          },
        },
        {
          path: "step5",
          name: "changeMotpPinStep5",
          description: "mOTP PIN관리 > PIN 번호 변경 > 변경완료 MOTP-05-02-01",
          component: () => import("@/views/templates/auth/changeMotpPinStep5"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
        // {
        //   path: "step8",
        //   name: "changeMotpPinStep8",
        //   description: "mOTP PIN관리 >  인증오류 ",
        //   component: () => import("@/views/templates/auth/changeMotpPinStep8"),
        //   meta: {
        //     roles: ["login"],
        //   },
        // },
        {
          path: "step9",
          name: "changeMotpPinStep9",
          description: "mOTP PIN관리 >  기존 MOPT 없음 MOTP-05-01-02",
          component: () => import("@/views/templates/auth/changeMotpPinStep9"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
      ],
    },
    // {
    //   path: "unlockAuthErrMotp",
    //   name: "unlockAuthErrMotp",
    //   redirect: { name: "unlockAuthErrMotpStep1" },
    //   description: "mOTP 인증번호 오류해제",
    //   component: () => import("@/views/templates/auth/unlockAuthErrMotp"),
    //   children: [
    //     {
    //       path: "step1",
    //       name: "unlockAuthErrMotpStep1",
    //       description: "mOTP 인증번호 오류 해제 ",
    //       component: () => import("@/views/templates/auth/unlockAuthErrMotpStep1"),
    //       meta: {
    //         roles: ["login"],
    //         step: 1,
    //       },
    //     },
    //     {
    //       path: "step2",
    //       name: "unlockAuthErrMotpStep2",
    //       description: "mOTP 인증번호 오류 해제 (PIN 인증) ",
    //       component: () => import("@/views/templates/auth/unlockAuthErrMotpStep2"),
    //       meta: {
    //         roles: ["login"],
    //         step: 2,
    //       },
    //     },
    //     {
    //       path: "step3",
    //       name: "unlockAuthErrMotpStep3",
    //       description: "mOTP 인증번호 오류 해제 (계좌인증) ",
    //       component: () => import("@/views/templates/auth/unlockAuthErrMotpStep3"),
    //       meta: {
    //         roles: ["login"],
    //         step: 3,
    //       },
    //     },
    //     {
    //       path: "step4",
    //       name: "unlockAuthErrMotpStep4",
    //       description: "mOTP 인증번호 오류 해제 (변경완료) ",
    //       component: () => import("@/views/templates/auth/unlockAuthErrMotpStep4"),
    //       meta: {
    //         roles: ["login"],
    //         isLast: true,
    //       },
    //     },
    //     {
    //       path: "step5",
    //       name: "unlockAuthErrMotpStep5",
    //       description: "mOTP 인증번호 오류 해제 (motp인증실패) ",
    //       component: () => import("@/views/templates/auth/unlockAuthErrMotpStep5"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //   ],
    // },
    {
      path: "discardOrReportMotp",
      name: "discardOrReportMotp",
      description: "mOTP 사고신고/폐기",
      component: () => import("@/views/templates/auth/discardOrReportMotp"),
      children: [
        {
          path: "mainState1",
          name: "mainState1",
          description: "mOTP 사고신고/폐기 선택 > MOTP-06-01-01",
          component: () => import("@/views/templates/auth/discardOrReportMotpState1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "mainState2",
          name: "mainState2",
          description: "mOTP 사고신고해제/폐기 선택 > MOTP-06-01-02",
          component: () => import("@/views/templates/auth/discardOrReportMotpState2"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "mainState3",
          name: "mainState3",
          description: "mOTP 미등록 -> 발급 > MOTP-06-01-03",
          component: () => import("@/views/templates/auth/discardOrReportMotpState3"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "reportMotpStep1",
          name: "reportMotpStep1",
          description: "mOTP 사고신고 > MOTP-06-02-01",
          component: () => import("@/views/templates/auth/reportMotpStep1"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "reportMotpStep1-1",
          name: "reportMotpStep1-1",
          description: "mOTP 사고신고 계좌인증 > page-01-06-01",
          component: () => import("@/views/templates/auth/reportMotpStep1-1"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "reportMotpStep2",
          name: "reportMotpStep2",
          description: "mOTP 사고신고 > MOTP-06-03-01",
          component: () => import("@/views/templates/auth/reportMotpStep2"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
        {
          path: "revocReportMotpStep1",
          name: "revocReportMotpStep1",
          description: "mOTP 사고신고 해제 > MOTP-06-04-01",
          component: () => import("@/views/templates/auth/revocReportMotpStep1"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "revocReportMotpStep1-1",
          name: "revocReportMotpStep1-1",
          description: "계좌인증 > page-01-06-01",
          component: () => import("@/views/templates/auth/revocReportMotpStep1-1"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "revocReportMotpStep1-2",
          name: "revocReportMotpStep1-2",
          description: "mOTP 발급/재발급-step3(sms, email, tokenOTP 인증 선택) page-01-09-01",
          component: () => import("@/views/templates/auth/revocReportMotpStep1-2"),
          meta: {
            roles: ["login"],
            step: 4,
          },
        },
        {
          path: "revocReportMotpStep1-3",
          name: "revocReportMotpStep1-3",
          description: "mOTP 발급/재발급-step4(sms, email 인증) page-01-07-02",
          component: () => import("@/views/templates/auth/revocReportMotpStep1-3"),
          meta: {
            roles: ["login"],
            step: 5,
          },
        },
        {
          path: "revocReportMotpStep1-4",
          name: "revocReportMotpStep1-4",
          description: "mOTP 발급/재발급-step5(otp 인증) page-01-10-01",
          component: () => import("@/views/templates/auth/revocReportMotpStep1-4"),
          meta: {
            roles: ["login"],
            step: 6,
          },
        },
        {
          path: "revocReportMotpStep2",
          name: "revocReportMotpStep2",
          description: "mOTP 사고신고 해제 > MOTP-06-05-01",
          component: () => import("@/views/templates/auth/revocReportMotpStep2"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
        {
          path: "discardMotpStep1",
          name: "discardMotpStep1",
          description: "mOTP 폐기 > MOTP-06-06-01",
          component: () => import("@/views/templates/auth/discardMotpStep1"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "discardMotpStep1-1",
          name: "discardMotpStep1-1",
          description: "계좌인증 > page-01-06-01",
          component: () => import("@/views/templates/auth/discardMotpStep1-1"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "discardMotpStep2",
          name: "discardMotpStep2",
          description: "mOTP 폐기 > MOTP-06-07-01",
          component: () => import("@/views/templates/auth/discardMotpStep2"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
      ],
    },
    // {
    //   path: "certnStupModfiMotp",
    //   name: "certnStupModfiMotp",
    //   redirect: { name: "certnStupModfiMotpStep1" },
    //   component: () => import("@/views/templates/auth/certnStupModfiMotp"),
    //   children: [
    //     {
    //       path: "step1",
    //       name: "certnStupModfiMotpStep1",
    //       description: "mOTP 인증설정 변경 MOTP-07-01-01",
    //       component: () => import("@/views/templates/auth/certnStupModfiMotpStep1"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //     {
    //       path: "step2",
    //       name: "certnStupModfiMotpStep2",
    //       description: "mOTP 인증설정 변경 > motp pin 인증 MOTP-01-08-01",
    //       component: () => import("@/views/templates/auth/certnStupModfiMotpStep2"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //     {
    //       path: "step2-1",
    //       name: "certnStupModfiMotpStep2-1",
    //       description: "mOTP 인증설정 변경 > motp pin 인증 MOTP-01-08-01",
    //       component: () => import("@/views/templates/auth/certnStupModfiMotpStep2-1"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //     {
    //       path: "step3",
    //       name: "certnStupModfiMotpStep3",
    //       description: "mOTP 인증설정 변경 > motp pin 인증 > 하루이체한도 MOTP-01-03-01",
    //       component: () => import("@/views/templates/auth/certnStupModfiMotpStep3"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //     {
    //       path: "step3-1",
    //       name: "certnStupModfiMotpStep3-1",
    //       description: "mOTP 인증설정 변경 > motp pin 인증 > 인증코드 입력방법  MOTP-01-05-01",
    //       component: () => import("@/views/templates/auth/certnStupModfiMotpStep3-1"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //     {
    //       path: "step4",
    //       name: "certnStupModfiMotpStep4",
    //       description: "mOTP 인증설정 변경 > motp pin 인증 > 하루이체한도 > 한번에 이체한도 MOTP-01-04-01",
    //       component: () => import("@/views/templates/auth/certnStupModfiMotpStep4"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //     {
    //       path: "step5",
    //       name: "certnStupModfiMotpStep5",
    //       description: "mOTP 인증설정 변경 > 설정변경 완료",
    //       component: () => import("@/views/templates/auth/certnStupModfiMotpStep5"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //     {
    //       path: "step5-1",
    //       name: "certnStupModfiMotpStep5-1",
    //       description: "mOTP 인증설정 변경 > 설정변경 완료",
    //       component: () => import("@/views/templates/auth/certnStupModfiMotpStep5-1"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //     {
    //       path: "step6",
    //       name: "certnStupModfiMotpStep6",
    //       description: "mOTP 인증설정 변경 (motp인증실패)",
    //       component: () => import("@/views/templates/auth/certnStupModfiMotpStep6"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //     {
    //       path: "step7",
    //       name: "certnStupModfiMotpStep7",
    //       description: "mOTP 인증설정 변경 (motp발급)",
    //       component: () => import("@/views/templates/auth/certnStupModfiMotpStep7"),
    //       meta: {
    //         roles: ["login"],
    //       },
    //     },
    //   ],
    // },
    {
      path: "reregisterOtp",
      name: "reregisterOtp",
      description: "Token OTP 재등록",
      redirect: { name: "reregisterOtpStep1" },
      component: () => import("@/views/templates/auth/reregisterOtp"),
      children: [
        {
          path: "step1",
          name: "reregisterOtpStep1",
          description: "Token OTP 안내 페이지 MOTP-08-01-01",
          component: () => import("@/views/templates/auth/reregisterOtpStep1"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step2",
          name: "reregisterOtpStep2",
          description: "Token OTP 안내 페이지 > Token OTP를 발급받지 않은 경우 MOTP-08-01-02 / 이미 Token OTP로 등록되어 있는 경우 MOTP-08-01-03",
          component: () => import("@/views/templates/auth/reregisterOtpStep2"),
          meta: {
            roles: ["login"],
            step: 1,
          },
        },
        {
          path: "step3",
          name: "reregisterOtpStep3",
          description: "Token OTP 일련번호 선택 MOTP-08-02-01",
          component: () => import("@/views/templates/auth/reregisterOtpStep3"),
          meta: {
            roles: ["login"],
            step: 2,
          },
        },
        {
          path: "step4",
          name: "reregisterOtpStep4",
          description: "(인증1)계좌 인증 MOTP-01-06-01",
          component: () => import("@/views/templates/auth/reregisterOtpStep4"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "step5",
          name: "reregisterOtpStep5",
          description: "(본인인증5) 휴대폰/이메일 or mOTP 인증 MOTP-01-08-01, MOTP-01-08-01",
          component: () => import("@/views/templates/auth/reregisterOtpStep5"),
          meta: {
            roles: ["login"],
            step: 4,
          },
        },
        {
          path: "step6",
          name: "reregisterOtpStep6",
          description: "[본인인증2] mOTP인증과 휴대폰/이메일 인증 선택 화면 MOTP-01-07-01",
          component: () => import("@/views/templates/auth/reregisterOtpStep6"),
          meta: {
            roles: ["login"],
            step: 5,
          },
        },
        {
          path: "step7",
          name: "reregisterOtpStep7",
          description: "(본인인증3) Mobile OTP (mOTP) 인증 MOTP-01-06-01",
          component: () => import("@/views/templates/auth/reregisterOtpStep7"),
          meta: {
            roles: ["login"],
            step: 5,
          },
        },
        {
          path: "step8",
          name: "reregisterOtpStep8",
          description: "Token OTP 재등록 완료 MOTP-08-03-01",
          component: () => import("@/views/templates/auth/reregisterOtpStep8"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
        {
          path: "step9",
          name: "reregisterOtpStep9",
          description: "mOTP 발급/재발급-step6(하루이체한도) page-01-03-01",
          component: () => import("@/views/templates/auth/createMotpStep6"),
          meta: {
            roles: ["login"],
            step: 9,
            page: "reregisterOtp",
          },
        },
        {
          path: "step10",
          name: "reregisterOtpStep10",
          description: "mOTP 발급/재발급-step7(한번에이체한도) page-01-04-01",
          component: () => import("@/views/templates/auth/createMotpStep7"),
          meta: {
            roles: ["login"],
            step: 10,
            page: "reregisterOtp",
          },
        },
      ],
    },
    {
      path: "authPCMotp",
      name: "authPCMotp",
      description: "인증번호관리",
      redirect: { name: "authPCMotpStep1" },
      component: () => import("@/views/templates/auth/authPCMotp"),
      children: [
        {
          path: "authPCMotpStep1",
          name: "authPCMotpStep1",
          description: "mOTP 목록",
          component: () => import("@/views/templates/auth/authPCMotpStep1"),
          meta: {
            step: 1,
            transparent: true,
          },
        },
        {
          path: "authPCMotpStep2",
          name: "authPCMotpStep2",
          description: "mOTP 정상인경우",
          component: () => import("@/views/templates/auth/authPCMotpStep2"),
          meta: {
            step: 1,
          },
        },
        {
          path: "authPCMotpStep3",
          name: "authPCMotpStep3",
          description: "mOTP 오류인경우",
          component: () => import("@/views/templates/auth/authPCMotpStep3"),
          meta: {
            step: 2,
          },
        },
        {
          path: "authPCMotpStep4",
          name: "authPCMotpStep4",
          description: "mOTP 폐기인경우",
          component: () => import("@/views/templates/auth/authPCMotpStep4"),
          meta: {
            step: 2,
          },
        },
        {
          path: "authPCMotpStep5",
          name: "authPCMotpStep5",
          description: "mOTP PIN번호 오류",
          component: () => import("@/views/templates/auth/authPCMotpStep5"),
          meta: {
            step: 2,
          },
        },
        {
          path: "authPCMotpStep6",
          name: "authPCMotpStep6",
          description: "mOTP PIN번호 오류",
          component: () => import("@/views/templates/auth/authPCMotpStep6"),
          meta: {
            step: 2,
          },
        },
        {
          path: "unlockAuthErrMotpStep2",
          name: "unlockAuthErrMotpStep2",
          description: "mOTP 인증번호 오류 해제 (계좌인증) ",
          component: () => import("@/views/templates/auth/unlockAuthErrMotpStep2"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "unlockAuthErrMotpStep3",
          name: "unlockAuthErrMotpStep3",
          description: "mOTP 인증번호 오류 해제 (본인인증) ",
          component: () => import("@/views/templates/auth/unlockAuthErrMotpStep3"),
          meta: {
            roles: ["login"],
            step: 4,
          },
        },
        {
          path: "unlockAuthErrMotpStep4",
          name: "unlockAuthErrMotpStep4",
          description: "mOTP 인증번호 오류 해제 (변경완료) ",
          component: () => import("@/views/templates/auth/unlockAuthErrMotpStep4"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
        {
          path: "unlockAuthErrMotpStep5",
          name: "unlockAuthErrMotpStep5",
          description: "mOTP 발급정보 없음 ",
          component: () => import("@/views/templates/auth/unlockAuthErrMotpStep5"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
        {
          path: "certnStupModfiMotpStep2-1",
          name: "certnStupModfiMotpStep2-1",
          description: "mOTP 인증설정 변경 > motp pin 인증 MOTP-01-08-01",
          component: () => import("@/views/templates/auth/certnStupModfiMotpStep2-1"),
          meta: {
            roles: ["login"],
            step: 3,
          },
        },
        {
          path: "certnStupModfiMotpStep3-1",
          name: "certnStupModfiMotpStep3-1",
          description: "mOTP 인증설정 변경 > motp pin 인증 > 인증코드 입력방법  MOTP-01-05-01",
          component: () => import("@/views/templates/auth/certnStupModfiMotpStep3-1"),
          meta: {
            roles: ["login"],
            step: 4,
          },
        },
        {
          path: "certnStupModfiMotpStep5-1",
          name: "certnStupModfiMotpStep5-1",
          description: "mOTP 인증설정 변경 > 설정변경 완료",
          component: () => import("@/views/templates/auth/certnStupModfiMotpStep5-1"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
        {
          path: "certnStupModfiMotpStep7",
          name: "certnStupModfiMotpStep7",
          description: "mOTP 인증설정 변경 > motp 발급정보 없음",
          component: () => import("@/views/templates/auth/certnStupModfiMotpStep7"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
      ],
    },
    {
      path: "motpTest",
      name: "motpTest",
      description: "motp테스트",
      component: () => import("@/views/templates/auth/authMotpTest"),
      meta: {},
    },
    {
      path: "createFidoPincode",
      name: "createFidoPincode",
      redirect: { name: "createFidoPincodeCertnIdPw" },
      component: () => import("@/views/templates/auth/createFidoPincode"),
      children: [
        {
          path: "guideSimpleLogin",
          name: "guideSimpleLogin",
          description: "간편로그인 안내(main 화면)",
          component: () => import("@/views/templates/auth/guideSimpleLogin"),
          meta: {
            layout: "default",
            Step: 1,
          },
        },
        {
          path: "createFidoPincodeGuide",
          name: "createFidoPincodeGuide",
          description: "간편로그인 안내(login 화면)",
          component: () => import("@/views/templates/auth/createFidoPincodeGuide"),
          meta: {
            layout: "default",
            transparent: true,
            nation: true,
            goback: false,
            Step: 1,
          },
        },
        {
          path: "createFidoPincodeCertnIdPw",
          name: "createFidoPincodeCertnIdPw",
          description: "(인증1) 아이디/사용자 암호 인증 - MLGI-02-01-01",
          component: () => import("@/views/templates/auth/createFidoPincodeCertnIdPw"),
          meta: {
            layout: "default",
            Step: 2,
          },
        },
        {
          path: "step1",
          name: "createFidoPincodeStep1",
          description: "Fido Pincode 발급-step1(계좌인증)",
          component: () => import("@/views/templates/auth/createFidoPincodeStep1"),
          meta: {
            roles: ["login"],
            Step: 3,
          },
        },
        {
          path: "step2",
          name: "createFidoPincodeStep2",
          description: "Fido Pincode 발급-step3(인증수단으로 인증)",
          component: () => import("@/views/templates/auth/createFidoPincodeStep2"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
        {
          path: "createFidoPincodeStep3",
          name: "createFidoPincodeStep3",
          description: "Fido Pincode 단순변경-step3(단순변경)",
          component: () => import("@/views/templates/auth/createFidoPincodeStep3"),
          meta: {
            roles: ["login"],
            isLast: true,
          },
        },
      ],
    },
    {
      path: "qrCodeTest",
      name: "qrCodeTest",
      description: "qr테스트",
      component: () => import("@/views/templates/auth/qrCodeTest"),
      meta: {},
    },
    {
      path: "lvbdInfoValdnPushPage",
      name: "lvbdInfoValdnPushPage",
      description: "생체정보검증 push 화면",
      component: () => import("@/views/templates/auth/lvbdInfoValdnPushPage"),
      meta: {},
    },

    // {
    //   path: "guideSimpleLogin",
    //   name: "guideSimpleLogin",
    //   description: "간편로그인 안내",
    //   component: () => import("@/views/templates/auth/guideSimpleLogin"),
    //   meta: {
    //     layout: "default",
    //   },
    // },
  ],
};

export default auth;
